module.exports = __webpack_public_path__ + "static/media/DSC_2881.6804389d.jpg";